import CookieConsent from '@inova/cookie-consent';

function preventCookieConsentRefresh() {
  const form = document.querySelector('[data-inova-cookie-settings]').querySelector('form');
  const settingsButton = document.querySelector('[data-inova-cookie-trigger="show-settings"]');
  const cookieNoticeContainer = document.querySelector('[data-inova-cookie-notice]');

  if (settingsButton) {
    settingsButton.addEventListener('click', () => {
      cookieNoticeContainer.setAttribute('aria-hidden', true);
    });
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const body = new FormData(form);
    const url = form.getAttribute('action');
    const method = form.getAttribute('method');

    fetch(url, {
      method,
      body,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(async (response) => {
      if (cookieNoticeContainer) {
        cookieNoticeContainer.remove();
      }
      document.querySelector('[data-inova-cookie-settings]').setAttribute('aria-hidden', true);
      const consent = await response.json();
      window.dispatchEvent(new CustomEvent('consent-update', { detail: { consent } }));
    });
  });
}

function initCookieConsentToggle() {
  const cookieConsentButton = document.querySelector('[data-open-cookie-consent]');
  const cookieSettings = document.querySelector('[data-inova-cookie-settings]');

  if (cookieConsentButton) {
    cookieConsentButton.addEventListener('click', () => {
      if (document.querySelector('[data-inova-cookie-notice]')) {
        return;
      }
      cookieSettings.removeAttribute('aria-hidden');

      const locale = cookieSettings.getAttribute('data-inova-locale');
      if (locale === 'nl_BE') {
        preventCookieConsentRefresh();
      }

      (new CookieConsent(document)).showSettings();
    });
  }
}

export default function initCookieConsent() {
  if (document.querySelector('[data-inova-cookie-notice]') !== null) {
    const cookieConsent = new CookieConsent(document);
    let timeout = 0;
    const locale = document.querySelector('[data-inova-cookie-notice]').getAttribute('data-inova-locale');
    if (locale === 'nl_BE') {
      preventCookieConsentRefresh();
      timeout = 2000;
    }
    setTimeout(() => cookieConsent.showNotice(), timeout);
  }

  initCookieConsentToggle();
}
